module.exports = __webpack_public_path__ + "img/stamp.6f3d19be.png";